import React, { Fragment, Component } from "react";
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
  Input,
  Label,
  FormGroup,
  CustomInput,
} from "reactstrap";
import { ConfirmAlert } from "../../../../../helpers/ui/alert";
import {
  AvForm,
  AvGroup,
  AvInput,
  AvField,
  AvCheckboxGroup,
  AvCheckbox,
} from "availity-reactstrap-validation";

import { Link, useHistory, Redirect } from "react-router-dom";

import apiResponse from "../../../../../services/apiResponse";

import CreateBloc from "./../Blocs/CreateBloc";
import CustomSelect from "../../../../../helpers/ui/CustomSelect";
import {
  FileInput,
  generateFormData,
} from "../../../../../helpers/ui/FileInput";
import DatePicker from "../../../../../helpers/ui/DatePicker";

var reformatOptions = function (raw, label, value) {
  return raw.map(function (data) {
    var newObj = {};
    newObj["label"] = data[label];
    newObj["value"] = data[value];

    return newObj;
  });
};

class ExternalInputComponent extends Component {
  createBloc = new CreateBloc();

  constructor(props) {
    super(props);
    this.state = {
      dataForm: {},
      optionGender: [
        { label: "Laki-laki", value: "L" },
        { label: "Perempuan", value: "P" },
      ],
      birthOptionNationality: [
        { label: "Dalam Negeri", value: "Dalam Negeri" },
        { label: "Luar Negeri", value: "Luar Negeri" },
      ],
      birthOptionProvince: [],
      birthSelectedProvince: "",
      birthOptionCity: [],
      birthSelectedCity: "",
      birthOptionCountry: [],
      birthSelectedCountry: "61b47307-167d-489f-bb6c-c1c9662acab3", // Indonesia
      birthSelectedNational: "Dalam Negeri",
      isLocal: 1,
      //------
      OptionReligion: [],
      OptionMaritalStatus: [],
      OptionBloodType: [],
      domicileOptionProvince: [],
      domicileOptionCity: [],
      domicileOptionDistrict: [],
      domicileOptionVillage: [],
      identityOptionProvince: [],
      identityOptionCity: [],
      identityOptionDistrict: [],
      identityOptionVillage: [],
      OptionBank: [],
      OptionUnit: [],
      OptionEmployeeType: [],
      OptionEmployeeStatus: [],
      OptionSallaryFrom: [
        { label: "Pusat", value: "Pusat" },
        { label: "Daerah", value: "Daerah" },
      ],
      OptionEmployeeStatusDesc: [],
      OptionEmployeeStatusPosition: [],
      educationOption: [],
      rankOption: [],
      positionChannel: [],
      OptionEmpCategories: [],
      OptionMinistries: [],
      categorySelected: "",
      polaKerjaOptions: [],

      failedInfo: "",
      enrollnumber: "",
    };

    this.timeout = null;
  }

  reformatOptions = (raw, label, value) => {
    return raw.map(function (data) {
      var newObj = {};
      newObj["label"] = data[label];
      newObj["value"] = data[value];
      newObj["model"] = data;

      return newObj;
    });
  };

  // Start Select Area
  handleBirthSelectNationality = (birthSelectNationality) => {
    let selected = birthSelectNationality.value;
    if (selected == "Dalam Negeri") {
      this.setState({
        birthSelectedCountry: "61b47307-167d-489f-bb6c-c1c9662acab3", // Indonesia
        isLocal: 1,
      });
    } else {
      this.setState({
        birthSelectedCountry: "",
        isLocal: 0,
      });
    }
  };

  handleBirthSelectCountry = (birthSelectedCountry) => {
    let selected = birthSelectedCountry.value;
    this.getBirthProvinceByCountry(selected);
  };

  handleBirthSelectProvince = (birthSelectedProvince) => {
    let selected = birthSelectedProvince.value;
    this.getBirthCityByProvince(selected);
  };

  // get data city where province selected
  getBirthCityByProvince = (province_uuid) => {
    this.createBloc.fetchRegionCity({
      is_local: 1,
      type: 3,
      parent_uuid: province_uuid,
    });
  };

  handleDomicileSelectProvince = (domicileSelectedProvince) => {
    let selected = domicileSelectedProvince.value;
    this.getDomicileCityByProvince(selected);
  };

  // get data city where province selected
  getDomicileCityByProvince = (province_uuid) => {
    this.createBloc.fetchDomicileCity({
      is_local: 1,
      type: 3,
      parent_uuid: province_uuid,
    });
  };

  handleDomicileSelectCity = (domicileSelectedCity) => {
    let selected = domicileSelectedCity.value;
    this.getDomicileDistrictByCity(selected);
  };

  // get data district where city selected
  getDomicileDistrictByCity = (city_uuid) => {
    this.createBloc.fetchDomicileDistrict({
      is_local: 1,
      type: 4,
      parent_uuid: city_uuid,
    });
  };

  handleDomicileSelectDistrict = (domicileSelectedDistrict) => {
    let selected = domicileSelectedDistrict.value;
    this.getDomicileVillageByDistrict(selected);
  };

  // get data village where district selected
  getDomicileVillageByDistrict = (district_uuid) => {
    this.createBloc.fetchDomicileVillage({
      is_local: 1,
      type: 5,
      parent_uuid: district_uuid,
    });
  };

  // ---- Domicile x Identity

  handleIdentitySelectProvince = (identitySelectedProvince) => {
    let selected = identitySelectedProvince.value;
    this.getIdentityCityByProvince(selected);
  };

  // get data city where province selected
  getIdentityCityByProvince = (province_uuid) => {
    this.createBloc.fetchIdentityCity({
      is_local: 1,
      type: 3,
      parent_uuid: province_uuid,
    });
  };

  handleIdentitySelectCity = (identitySelectedCity) => {
    let selected = identitySelectedCity.value;
    this.getIdentityDistrictByCity(selected);
  };

  // get data district where city selected
  getIdentityDistrictByCity = (city_uuid) => {
    this.createBloc.fetchIdentityDistrict({
      is_local: 1,
      type: 4,
      parent_uuid: city_uuid,
    });
  };

  handleIdentitySelectDistrict = (identitySelectedDistrict) => {
    let selected = identitySelectedDistrict.value;
    this.getIdentityVillageByDistrict(selected);
  };

  // get data village where district selected
  getIdentityVillageByDistrict = (district_uuid) => {
    this.createBloc.fetchIdentityVillage({
      is_local: 1,
      type: 5,
      parent_uuid: district_uuid,
    });
  };

  // End Select Area

  submitData = async () => {
    const formData = generateFormData(this.state.dataForm, [
      "file",
      "file_kk",
    ]);
    await this.createBloc.fetchCreate(formData);
  };

  handleInputChange = (value) => {
    this.setState({ enrollnumber: value });

    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.checkEnrollExist(value);
    }, 500); // Delay 500ms
  };

  checkEnrollExist = async (enroll) => {
    await this.createBloc.checkEnrollExist({
      enroll: enroll,
    });
  };

  handlerOnSubmit = (e, values) => {
    e.preventDefault();
    this.setState({
      dataForm: values,
      confirm: true,
    });
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          loadingTitle: "Mengirim data...",
          confirm: false,
        };
        this.submitData();
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  componentDidMount() {
    this.createBloc.createChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            loading: false,
            success: true,
          });
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
            failedInfo: "Data gagal disimpan",
          });
          break;
        default:
          break;
      }
    });

    this.createBloc.employeeCategoriesChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            OptionEmpCategories: reformatOptions(
              result.data.response.result,
              "employee_categories_name",
              "employee_categories_uuid"
            ),
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.createBloc.fetchEmployeeCategories({
      parent_uuid: this.props.categoryUuid,
    });

    this.createBloc.ministriesChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            OptionMinistries: reformatOptions(
              result.data.response.result,
              "ministry_name",
              "ministry_uuid"
            ),
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.createBloc.fetchMinistries();

    // get data birth country
    this.createBloc.regionCountryChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            //console.log(response)

            this.setState({
              birthOptionCountry: reformatOptions(
                response.result,
                "region_name",
                "region_uuid"
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.createBloc.fetchRegionCountry({
      type: 1,
    });

    // get data province
    this.createBloc.regionProvinceChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            //console.log(response)

            this.setState({
              birthOptionProvince: reformatOptions(
                response.result,
                "region_name",
                "region_uuid"
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.createBloc.fetchRegionProvince({
      is_local: 1,
      type: 2,
    });

    // get city
    this.createBloc.regionCityChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;

            this.setState({
              birthOptionCity: reformatOptions(
                response.result,
                "region_name",
                "region_uuid"
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    //this.getBirthCityByProvince(this.dataForm ? this.dataForm.employee_place_of_birth_province_uuid : '')

    // get data religion
    this.createBloc.religionChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            //console.log(response)

            this.setState({
              OptionReligion: reformatOptions(
                response.result,
                "religion_name",
                "religion_uuid"
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.createBloc.fetchReligion({});

    // get data marital status
    this.createBloc.maritalStatusChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            //console.log(response)

            this.setState({
              OptionMaritalStatus: reformatOptions(
                response.result,
                "marital_status_name",
                "marital_status_uuid"
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.createBloc.fetchMaritalStatus({});

    // CHANNEL ADDRESS START

    // get data province domicile
    this.createBloc.domicileProvinceChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            //console.log(response)

            this.setState({
              domicileOptionProvince: reformatOptions(
                response.result,
                "region_name",
                "region_uuid"
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.createBloc.fetchDomicileProvince({
      is_local: 1,
      type: 2,
    });

    // get city domicile
    this.createBloc.domicileCityChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;

            this.setState({
              domicileOptionCity: reformatOptions(
                response.result,
                "region_name",
                "region_uuid"
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    //this.getDomicileCityByProvince(this.dataForm ? this.dataForm.employee_domicile_province_uuid : '')

    // get district domicile
    this.createBloc.domicileDistrictChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;

            this.setState({
              domicileOptionDistrict: reformatOptions(
                response.result,
                "region_name",
                "region_uuid"
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    //this.getDomicileDistrictByCity(this.dataForm ? this.dataForm.employee_domicile_city_uuid : '')

    // get village domicile
    this.createBloc.domicileVillageChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;

            this.setState({
              domicileOptionVillage: reformatOptions(
                response.result,
                "region_name",
                "region_uuid"
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    //this.getDomicileVillageByDistrict(this.dataForm ? this.dataForm.employee_domicile_districts_uuid : '')

    // get data province identity
    this.createBloc.identityProvinceChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            //console.log(response)

            this.setState({
              identityOptionProvince: reformatOptions(
                response.result,
                "region_name",
                "region_uuid"
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.createBloc.fetchIdentityProvince({
      is_local: 1,
      type: 2,
    });

    // get city identity
    this.createBloc.identityCityChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;

            this.setState({
              identityOptionCity: reformatOptions(
                response.result,
                "region_name",
                "region_uuid"
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    //this.getIdentityCityByProvince(this.dataForm ? this.dataForm.employee_identity_province_uuid : '')

    // get district identity
    this.createBloc.identityDistrictChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;

            this.setState({
              identityOptionDistrict: reformatOptions(
                response.result,
                "region_name",
                "region_uuid"
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    //this.getIdentityDistrictByCity(this.dataForm ? this.dataForm.employee_identity_city_uuid : '')

    // get village identity
    this.createBloc.identityVillageChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;

            this.setState({
              identityOptionVillage: reformatOptions(
                response.result,
                "region_name",
                "region_uuid"
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    //this.getIdentityVillageByDistrict(this.dataForm ? this.dataForm.employee_identity_districts_uuid : '')

    // CHANNEL ADDRESS END

    // get data blood type
    this.createBloc.bloodTypeChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            //console.log(response)

            this.setState({
              OptionBloodType: reformatOptions(
                response.result,
                "blood_type_name",
                "blood_type_uuid"
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.createBloc.fetchBloodType({});

    // get data bank
    this.createBloc.bankChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            //console.log(response)

            this.setState({
              OptionBank: reformatOptions(
                response.result,
                "bank_name",
                "bank_uuid"
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.createBloc.fetchBank({});

    // get data workunit
    this.createBloc.workUnitChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            //console.log(response)

            this.setState({
              OptionUnit: reformatOptions(
                response.result,
                "work_unit_name_tabs",
                "work_unit_uuid"
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.createBloc.fetchWorkUnit({});

    // get data employee type
    this.createBloc.employeeTypeChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            //console.log(response)

            this.setState({
              OptionEmployeeType: reformatOptions(
                response.result,
                "employee_type_name",
                "employee_type_uuid"
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.createBloc.fetchEmployeeType({});

    // get data employee status
    this.createBloc.employeeStatusChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            //console.log(response)

            this.setState({
              OptionEmployeeStatus: reformatOptions(
                response.result,
                "employee_status_name",
                "employee_status_uuid"
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.createBloc.fetchEmployeeStatus({});

    // get data status desc
    this.createBloc.employeeStatusDescriptionChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            //console.log(response)

            this.setState({
              OptionEmployeeStatusDesc: reformatOptions(
                response.result,
                "employee_status_description_name",
                "employee_status_description_uuid"
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.createBloc.fetchEmployeeStatusDescription({});

    // get data status position
    this.createBloc.employeeStatusPositionChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            //console.log(response)

            this.setState({
              OptionEmployeeStatusPosition: reformatOptions(
                response.result,
                "employee_status_position_name",
                "employee_status_position_uuid"
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.createBloc.fetchEmployeeStatusPosition({});

    this.createBloc.educationChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            educationOption: reformatOptions(
              result.data.response.result,
              "education_name",
              "education_uuid"
            ),
            loadingWorkUnit: false,
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.createBloc.fetchEducation({ is_default: 1 });

    this.createBloc.rankChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            rankOption: result.data.response.result.map(function (data) {
              var newObj = {};
              newObj["label"] = `${data.rank_name} (${data.rank_group_room})`;
              newObj["value"] = data.rank_uuid;

              return newObj;
            }),
            loadingRank: false,
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.createBloc.fetchRank();

    this.createBloc.positionChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            positionOption: reformatOptions(
              result.data.response.result,
              "position_name",
              "position_uuid"
            ),
            loadingPosition: false,
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.createBloc.fetchPosition();

    this.createBloc.polaKerjaChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            //console.log(response)
            this.setState({
              polaKerjaOptions: this.reformatOptions(
                response.result,
                "working_pattern_name",
                "working_pattern_uuid"
              ),
              isLoadingOptPolaKerja: false,
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.createBloc.fetchPolaKerja();

    this.createBloc.checkEnrollChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.LOADING:
          this.setState({
            loading: true,
            loadingTitle: "Mengecek Data",
          });
          break;

        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            if (response.total > 0) {
              this.setState({
                loading: false,
                failed: true,
                failedInfo: response.message,
                enrollnumber: "",
              });
            } else {
              this.setState({
                loading: false,
                // failed: true,
                // failedInfo : response.message
              });
            }
          } else {
            this.setState({
              loading: false,
              failed: true,
              failedInfo: "Gagal mencari data",
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
  }

  componentWillUnmount() {
    this.createBloc.createChannel?.unsubscribe();
    this.createBloc.regionCountryChannel?.unsubscribe();
    this.createBloc.regionProvinceChannel?.unsubscribe();
    this.createBloc.regionCityChannel?.unsubscribe();
    this.createBloc.religionChannel?.unsubscribe();
    this.createBloc.maritalStatusChannel?.unsubscribe();
    this.createBloc.domicileProvinceChannel?.unsubscribe();
    this.createBloc.domicileCityChannel?.unsubscribe();
    this.createBloc.domicileDistrictChannel?.unsubscribe();
    this.createBloc.domicileVillageChannel?.unsubscribe();
    this.createBloc.identityProvinceChannel?.unsubscribe();
    this.createBloc.identityCityChannel?.unsubscribe();
    this.createBloc.identityDistrictChannel?.unsubscribe();
    this.createBloc.identityVillageChannel?.unsubscribe();
    this.createBloc.bloodTypeChannel?.unsubscribe();
    this.createBloc.bankChannel?.unsubscribe();
    this.createBloc.workUnitChannel?.unsubscribe();
    this.createBloc.employeeTypeChannel?.unsubscribe();
    this.createBloc.employeeStatusChannel?.unsubscribe();
    this.createBloc.employeeStatusDescriptionChannel?.unsubscribe();
    this.createBloc.employeeStatusPositionChannel?.unsubscribe();
    this.createBloc.educationChannel?.unsubscribe();
    this.createBloc.rankChannel?.unsubscribe();
    this.createBloc.positionChannel?.unsubscribe();
    this.createBloc.polaKerjaChannel?.unsubscribe();
    this.createBloc.checkEnrollChannel?.unsubscribe();
  }

  render() {
    return (
      <Fragment>
        <Row>
          <Col className="col-12">
            <Card>
              <CardBody>
                <CardTitle>Tambah Pegawai (Eksternal)</CardTitle>
                <CardSubtitle className="mb-3">
                  Setiap isian yang bertanda (
                  <span className="text-danger">*</span>) adalah wajib diisi.
                </CardSubtitle>
                <hr />
                <AvForm
                  className="needs-validation"
                  onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                >
                  <Row className="mb-3">
                    <label htmlFor="kat" className="col-md-3 col-form-label">
                      Kategori Pegawai <span className="text-danger">*</span>
                    </label>
                    <Col md="5">
                      <CustomSelect
                        name="employee_categories_uuid"
                        errorMessage="Pilih Kategori Pegawai"
                        options={this.state.OptionEmpCategories}
                        onChange={(v) =>
                          this.setState({ categorySelected: v.value })
                        }
                        validate={{ required: { value: true } }}
                        placeholder="Pilih Kategori Pegawai"
                      />
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label htmlFor="kat" className="col-md-3 col-form-label">
                      Instansi <span className="text-danger">*</span>
                    </label>
                    <Col md="5">
                      <CustomSelect
                        name="employee_ministry_uuid"
                        errorMessage="Pilih Instansi"
                        options={this.state.OptionMinistries}
                        validate={{ required: { value: true } }}
                        placeholder="Pilih Instansi"
                      />
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label className="col-md-3 col-form-label">
                      Tanggal Mulai Penugasan{" "}
                      <span className="text-danger">*</span>
                    </label>
                    <Col md="3">
                      {/* <AvField
                                                name="employee_assignment_start_date"
                                                placeholder="Tanggal Mulai Penugasan..."
                                                type="date"
                                                errorMessage="Masukkan Tanggal Mulai Penugasan"
                                                className="form-control"
                                                validate={{ required: { value: true } }}
                                                id="employee_assignment_start_date"
                                            /> */}
                      <DatePicker
                        name="employee_assignment_start_date"
                        id="employee_assignment_start_date"
                        placeholder="Tanggal Mulai Penugasan..."
                        errorMessage="Masukkan Tanggal Mulai Penugasan"
                        isWeekday={true}
                        dateFormat="dd/MM/yyyy"
                        validate={{ required: { value: true } }}
                      // minDate={moment().add(5, 'days').format('YYYY-MM-DD')}
                      // minDate={this.state.minDate}
                      />
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label className="col-md-3 col-form-label">
                      Tanggal Selesai Penugasan{" "}
                      <span className="text-danger">*</span>
                    </label>
                    <Col md="3">
                      {/* <AvField
                                                name="employee_assignment_end_date"
                                                placeholder="Tanggal Selesai Penugasan..."
                                                type="date"
                                                errorMessage="Masukkan Tanggal Selesai Penugasan"
                                                className="form-control"
                                                validate={{ required: { value: true } }}
                                                id="employee_assignment_end_date"
                                            /> */}
                      <DatePicker
                        name="employee_assignment_end_date"
                        id="employee_assignment_end_date"
                        placeholder="Tanggal Selesai Penugasan..."
                        errorMessage="Masukkan Tanggal Selesai Penugasan"
                        isWeekday={true}
                        dateFormat="dd/MM/yyyy"
                        validate={{ required: { value: true } }}
                      // minDate={moment().add(5, 'days').format('YYYY-MM-DD')}
                      // minDate={this.state.minDate}
                      />
                    </Col>
                  </Row>

                  <hr />

                  <Row className="mb-3">
                    <label className="col-md-3 col-form-label">
                      {this.state.categorySelected !=
                        "1d6805ff-6c56-4e08-ba4b-f666677cd237"
                        ? "NIP"
                        : "NRP"}{" "}
                      <span className="text-danger">*</span>
                    </label>
                    <Col md="5">
                      <AvField
                        name="employee_nip"
                        placeholder={`${this.state.categorySelected !=
                            "1d6805ff-6c56-4e08-ba4b-f666677cd237"
                            ? "NIP"
                            : "NRP"
                          }...`}
                        type="text"
                        errorMessage={`Masukkan ${this.state.categorySelected !=
                            "1d6805ff-6c56-4e08-ba4b-f666677cd237"
                            ? "NIP"
                            : "NRP"
                          }`}
                        className="form-control"
                        validate={{ required: { value: true } }}
                        id="employee_nip"
                        minLength="18"
                        maxLength="18"
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-3 col-form-label">
                      Nama <span className="text-danger">*</span>
                    </label>
                    <Col md="5">
                      <AvField
                        name="employee_name"
                        placeholder="Nama..."
                        type="text"
                        errorMessage="Masukkan Nama"
                        className="form-control"
                        validate={{ required: { value: true } }}
                        id="employee_name"
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-3 col-form-label">
                      Gelar Non Akademi Depan
                    </label>
                    <Col md="5">
                      <AvField
                        name="employee_front_title_non_academic"
                        placeholder="Gelar Non Akademi Depan..."
                        type="text"
                        errorMessage="Masukkan Gelar Non Akademi Depan"
                        className="form-control"
                        id="employee_front_title_non_academic"
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-3 col-form-label">
                      Gelar Non Akadami Belakang
                    </label>
                    <Col md="5">
                      <AvField
                        name="employee_end_title_non_academic"
                        placeholder="Gelar Non Akadami Belakang..."
                        type="text"
                        errorMessage="Masukkan Gelar Non Akadami Belakang"
                        className="form-control"
                        id="employee_end_title_non_academic"
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-3 col-form-label">
                      Gelar Depan
                    </label>
                    <Col md="5">
                      <AvField
                        name="employee_front_title"
                        placeholder="Gelar Depan..."
                        type="text"
                        errorMessage="Masukkan Gelar Depan"
                        className="form-control"
                        id="employee_front_title"
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-3 col-form-label">
                      Gelar Belakang
                    </label>
                    <Col md="5">
                      <AvField
                        name="employee_end_title"
                        placeholder="Gelar Belakang..."
                        type="text"
                        errorMessage="Masukkan Gelar Belakang"
                        className="form-control"
                        id="employee_end_title"
                      />
                    </Col>
                  </Row>
                  <hr />
                  <Row>
                    <Col md="5">
                      <label className="fw-bold">#Tempat Lahir</label>
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label
                      htmlFor="tempat_lahir"
                      className="col-md-3 col-form-label"
                    >
                      Dalam / Luar Negeri
                      {/* <span className="text-danger">*</span> */}
                    </label>
                    <Col md="5">
                      <CustomSelect
                        name="employee_place_of_birth_national"
                        errorMessage="Pilih Dalam / Luar Negeri Lahir"
                        onChange={this.handleBirthSelectNationality}
                        options={this.state.birthOptionNationality}
                        // validate={{ required: { value: true } }}
                        placeholder="Pilih Dalam / Luar Negeri Lahir"
                        defaultValue={this.state.birthSelectedNational}
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label
                      htmlFor="tempat_lahir"
                      className="col-md-3 col-form-label"
                    >
                      Negara
                      {/* <span className="text-danger">*</span> */}
                    </label>
                    <Col md="5">
                      <CustomSelect
                        name="employee_place_of_birth_country_uuid"
                        errorMessage="Pilih Negara Lahir"
                        onChange={this.handleBirthSelectCountry}
                        options={this.state.birthOptionCountry}
                        // validate={{ required: { value: true } }}
                        placeholder="Pilih Negara Lahir"
                        defaultValue={this.state.birthSelectedCountry}
                        isDisabled={this.state.isLocal == 0 ? false : true}
                      />
                    </Col>
                  </Row>
                  <Row
                    className="mb-3"
                    style={this.state.isLocal == 0 ? { display: "none" } : {}}
                  >
                    <label className="col-md-3 col-form-label">
                      Provinsi Lahir
                      {/* <span className="text-danger">*</span> */}
                    </label>
                    <Col md="5">
                      <CustomSelect
                        name="employee_place_of_birth_province_uuid"
                        errorMessage="Pilih Provinsi Lahir"
                        onChange={this.handleBirthSelectProvince}
                        options={this.state.birthOptionProvince}
                        // validate={{ required: { value: this.state.isLocal == 0 ? false : true } }}
                        placeholder="Pilih Provinsi Lahir"
                      />
                    </Col>
                  </Row>
                  <Row
                    className="mb-3"
                    style={this.state.isLocal == 0 ? { display: "none" } : {}}
                  >
                    <label className="col-md-3 col-form-label">
                      Kota Lahir
                      {/* <span className="text-danger">*</span> */}
                    </label>
                    <Col md="5">
                      <CustomSelect
                        name="employee_place_of_birth_city_uuid"
                        errorMessage="Pilih Kota Lahir"
                        options={this.state.birthOptionCity}
                        // validate={{ required: { value: this.state.isLocal == 0 ? false : true } }}
                        placeholder="Pilih Kota Lahir"
                      />
                    </Col>
                  </Row>
                  <Row
                    className="mb-3"
                    style={this.state.isLocal == 1 ? { display: "none" } : {}}
                  >
                    <label
                      htmlFor="employee_place_of_birth_city_text"
                      className="col-md-3 col-form-label"
                    >
                      Kota Lahir
                      {/* <span className="text-danger">*</span> */}
                    </label>
                    <Col md="5">
                      <AvField
                        name="employee_place_of_birth_city_text"
                        placeholder="Kota..."
                        type="text"
                        errorMessage="Masukkan Kota"
                        className="form-control"
                        // validate={{ required: { value: this.state.isLocal == 1 ? false : true } }}
                        id="employee_place_of_birth_city_text"
                      />
                    </Col>
                  </Row>
                  <hr />
                  <Row className="mb-3">
                    <label className="col-md-3 col-form-label">
                      Tanggal Lahir
                      {/* <span className="text-danger">*</span> */}
                    </label>
                    <Col md="3">
                      {/* <AvField
                                                name="employee_date_of_birth"
                                                placeholder="Tanggal Lahir..."
                                                type="date"
                                                errorMessage="Masukkan Tanggal Lahir"
                                                className="form-control"
                                                validate={{ required: { value: true } }}
                                                id="employee_date_of_birth"
                                            /> */}
                      <DatePicker
                        name="employee_date_of_birth"
                        id="employee_date_of_birth"
                        placeholder="Tanggal Lahir..."
                        errorMessage="Masukkan Tanggal Lahir"
                        isWeekday={false}
                        dateFormat="dd/MM/yyyy"
                      // validate={{ required: { value: true } }}
                      // minDate={moment().add(5, 'days').format('YYYY-MM-DD')}
                      // minDate={this.state.minDate}
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-3 col-form-label">
                      Jenis Kelamin
                      {/* <span className="text-danger">*</span> */}
                    </label>
                    <Col md="3">
                      <CustomSelect
                        name="employee_gender"
                        errorMessage="Pilih Jenis Kelamin"
                        options={this.state.optionGender}
                        placeholder="Pilih Jenis Kelamin"
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-3 col-form-label">
                      Agama
                      {/* <span className="text-danger">*</span> */}
                    </label>
                    <Col md="3">
                      <CustomSelect
                        name="employee_religion_uuid"
                        errorMessage="Pilih Agama"
                        options={this.state.OptionReligion}
                        placeholder="Pilih Agama"
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-3 col-form-label">
                      Status Pernikahan
                      {/* <span className="text-danger">*</span> */}
                    </label>
                    <Col md="4">
                      <CustomSelect
                        name="employee_marital_status_uuid"
                        errorMessage="Pilih Status Pernikahan"
                        options={this.state.OptionMaritalStatus}
                        placeholder="Pilih Status Pernikahan"
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-3 col-form-label">
                      Golongan Darah
                    </label>
                    <Col md="4">
                      <CustomSelect
                        name="employee_blood_type_uuid"
                        errorMessage="Pilih Golongan Darah"
                        options={this.state.OptionBloodType}
                        placeholder="Pilih Golongan Darah"
                      />
                    </Col>
                  </Row>
                  <hr />
                  <Row className="mb-3">
                    <label className="col-md-3 col-form-label">
                      Alamat Tinggal
                      {/* <span className="text-danger">*</span> */}
                    </label>
                    <Col md="9">
                      <AvField
                        name="employee_domicile_address"
                        placeholder="Alamat Tinggal..."
                        type="textarea"
                        errorMessage="Masukkan Alamat Tinggal"
                        className="form-control"
                        // validate={{ required: { value: true } }}
                        id="employee_domicile_address"
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-3 col-form-label">
                      Provinsi
                      {/* <span className="text-danger">*</span> */}
                    </label>
                    <Col md="5">
                      <CustomSelect
                        name="employee_domicile_province_uuid"
                        errorMessage="Pilih Provinsi"
                        onChange={this.handleDomicileSelectProvince}
                        options={this.state.domicileOptionProvince}
                        // validate={{ required: { value: true } }}
                        placeholder="Pilih Provinsi"
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-3 col-form-label">
                      Kota/Kabupaten
                      {/* <span className="text-danger">*</span> */}
                    </label>
                    <Col md="5">
                      <CustomSelect
                        name="employee_domicile_city_uuid"
                        errorMessage="Pilih Kota"
                        onChange={this.handleDomicileSelectCity}
                        options={this.state.domicileOptionCity}
                        // validate={{ required: { value: true } }}
                        placeholder="Pilih Kota"
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-3 col-form-label">Kecamatan</label>
                    <Col md="5">
                      <CustomSelect
                        name="employee_domicile_districts_uuid"
                        errorMessage="Pilih Kecamatan"
                        onChange={this.handleDomicileSelectDistrict}
                        options={this.state.domicileOptionDistrict}
                        placeholder="Pilih Kecamatan"
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-3 col-form-label">
                      Desa/Kelurahan
                    </label>
                    <Col md="5">
                      <CustomSelect
                        name="employee_domicile_village_uuid"
                        errorMessage="Desa/Kelurahan"
                        options={this.state.domicileOptionVillage}
                        placeholder="Desa/Kelurahan"
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-3 col-form-label">
                      Kode Pos
                      {/* <span className="text-danger">*</span> */}
                    </label>
                    <Col md="3">
                      <AvField
                        name="employee_domicile_postal_code"
                        placeholder="Kode Pos..."
                        type="number"
                        errorMessage="Masukkan Kode Pos"
                        className="form-control"
                        // validate={{ required: { value: true } }}
                        id="employee_domicile_postal_code"
                      />
                    </Col>
                  </Row>
                  <hr />
                  <Row className="mb-3">
                    <label className="col-md-3 col-form-label">
                      Alamat KTP
                      {/* <span className="text-danger">*</span> */}
                    </label>
                    <Col md="9">
                      <AvField
                        name="employee_identity_address"
                        placeholder="Alamat KTP..."
                        type="textarea"
                        errorMessage="Masukkan Alamat KTP"
                        className="form-control"
                        // validate={{ required: { value: true } }}
                        id="employee_identity_address"
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-3 col-form-label">
                      Provinsi
                      {/* <span className="text-danger">*</span> */}
                    </label>
                    <Col md="5">
                      <CustomSelect
                        name="employee_identity_province_uuid"
                        errorMessage="Pilih Provinsi"
                        onChange={this.handleIdentitySelectProvince}
                        options={this.state.identityOptionProvince}
                        // validate={{ required: { value: true } }}
                        placeholder="Pilih Provinsi"
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-3 col-form-label">
                      Kota/Kabupaten
                      {/* <span className="text-danger">*</span> */}
                    </label>
                    <Col md="5">
                      <CustomSelect
                        name="employee_identity_city_uuid"
                        errorMessage="Pilih Kota"
                        onChange={this.handleIdentitySelectCity}
                        options={this.state.identityOptionCity}
                        // validate={{ required: { value: true } }}
                        placeholder="Pilih Kota"
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-3 col-form-label">Kecamatan</label>
                    <Col md="5">
                      <CustomSelect
                        name="employee_identity_districts_uuid"
                        errorMessage="Pilih Kecamatan"
                        onChange={this.handleIdentitySelectDistrict}
                        options={this.state.identityOptionDistrict}
                        placeholder="Pilih Kecamatan"
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-3 col-form-label">
                      Desa/Kelurahan
                    </label>
                    <Col md="5">
                      <CustomSelect
                        name="employee_identity_village_uuid"
                        errorMessage="Desa/Kelurahan"
                        options={this.state.identityOptionVillage}
                        placeholder="Desa/Kelurahan"
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-3 col-form-label">
                      Kode Pos
                      {/* <span className="text-danger">*</span> */}
                    </label>
                    <Col md="3">
                      <AvField
                        name="employee_identity_postal_code"
                        placeholder="Kode Pos..."
                        type="number"
                        errorMessage="Masukkan Kode Pos"
                        className="form-control"
                        // validate={{ required: { value: true } }}
                        id="employee_identity_postal_code"
                      />
                    </Col>
                  </Row>
                  <hr />
                  <Row className="mb-3">
                    <Label className="col-md-3 col-form-label">
                      Pangkat <span className="text-danger">*</span>
                    </Label>
                    <Col md="3">
                      <CustomSelect
                        name="employee_current_rank_uuid"
                        errorMessage="Pilih Pangkat"
                        placeholder="Pilih Pangkat"
                        options={this.state.rankOption}
                        //onChange={opt => this.setState({ type: opt.value })}
                        //defaultValue={this.state.detail?.employee_current_rank_uuid}
                        validate={{ required: { value: true } }}
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Label className="col-md-3 col-form-label">
                      Jabatan <span className="text-danger">*</span>
                    </Label>
                    <Col md="5">
                      <CustomSelect
                        name="employee_current_position_uuid"
                        errorMessage="Pilih Jabatan"
                        placeholder="Pilih Jabatan"
                        options={this.state.positionOption}
                        onChange={(opt) => this.setState({ type: opt.value })}
                        //defaultValue={this.state.detail?.employee_current_position_uuid}
                        validate={{ required: { value: true } }}
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-3 col-form-label">
                      Unit Kerja <span className="text-danger">*</span>
                    </label>
                    <Col md="5">
                      <CustomSelect
                        name="employee_current_work_unit_uuid"
                        errorMessage="Pilih Unit Kerja"
                        options={this.state.OptionUnit}
                        validate={{ required: { value: true } }}
                        placeholder="Pilih Unit Kerja..."
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-3 col-form-label">
                      Bank
                      {/* <span className="text-danger">*</span> */}
                    </label>
                    <Col md="5">
                      <CustomSelect
                        name="employee_bank_uuid"
                        errorMessage="Pilih Bank"
                        options={this.state.OptionBank}
                        // validate={{ required: { value: true } }}
                        placeholder="Pilih Bank..."
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-3 col-form-label">
                      Rekening Gaji
                      {/* <span className="text-danger">*</span> */}
                    </label>
                    <Col md="5">
                      <AvField
                        name="employee_bank_account_number"
                        placeholder="Rekening Gaji..."
                        type="number"
                        errorMessage="Masukkan Rekening Gaji"
                        className="form-control"
                        // validate={{ required: { value: true } }}
                        id="employee_bank_account_number"
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-3 col-form-label">
                      Nama Pemilik Rekening
                    </label>
                    <Col md="5">
                      <AvField
                        name="employee_bank_account_name"
                        placeholder="Nama Pemilik Rekening..."
                        type="text"
                        errorMessage="Masukkan Nama Pemilik Rekening"
                        className="form-control"
                        id="employee_bank_account_name"
                      />
                    </Col>
                  </Row>
                  {/* <Row className="mb-3">
                                        <label
                                            className="col-md-3 col-form-label"
                                        >
                                        Tipe Pegawai <span className="text-danger">*</span>
                                        </label>
                                        <Col md="5">
                                            <CustomSelect 
                                                name="employee_type_uuid"
                                                errorMessage="Pilih Tipe Pegawai"
                                                options={this.state.OptionEmployeeType} 
                                                validate={{ required: { value: true } }}
                                                placeholder="Pilih Tipe Pegawai..."
                                            />
                                        </Col>
                                    </Row> */}
                  <Row className="mb-3">
                    <label className="col-md-3 col-form-label">
                      Status Pegawai
                      {/* <span className="text-danger">*</span> */}
                    </label>
                    <Col md="5">
                      <CustomSelect
                        name="employee_status_uuid"
                        errorMessage="Pilih Status Pegawai"
                        options={this.state.OptionEmployeeStatus}
                        // validate={{ required: { value: true } }}
                        placeholder="Pilih Status Pegawai..."
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-3 col-form-label">
                      Status Penggajian
                      {/* <span className="text-danger">*</span> */}
                    </label>
                    <Col md="5">
                      <CustomSelect
                        name="employee_salary_paid_from"
                        errorMessage="Pilih Status Penggajian"
                        options={this.state.OptionSallaryFrom}
                        // validate={{ required: { value: true } }}
                        placeholder="Pilih Status Penggajian..."
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-3 col-form-label">
                      Keterangan Status
                      {/* <span className="text-danger">*</span> */}
                    </label>
                    <Col md="5">
                      <CustomSelect
                        name="employee_status_description_uuid"
                        errorMessage="Pilih Keterangan Status"
                        options={this.state.OptionEmployeeStatusDesc}
                        // validate={{ required: { value: true } }}
                        placeholder="Pilih Keterangan Status..."
                      />
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label className="col-md-3 col-form-label">
                      Kedudukan
                      {/* <span className="text-danger">*</span> */}
                    </label>
                    <Col md="5">
                      <CustomSelect
                        name="employee_status_position_uuid"
                        errorMessage="Pilih Kedudukan"
                        options={this.state.OptionEmployeeStatusPosition}
                        // validate={{ required: { value: true } }}
                        placeholder="Pilih Kedudukan..."
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-3 col-form-label">
                      Kartu Pegawai
                    </label>
                    <Col md="5">
                      <AvField
                        name="employee_karpeg_number"
                        placeholder="Kartu Pegawai..."
                        type="text"
                        errorMessage="Masukkan Kartu Pegawai"
                        className="form-control"
                        // validate={{ required: { value: true } }}
                        id="employee_karpeg_number"
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-3 col-form-label">
                      Askes / BPJS Kesehatan
                    </label>
                    <Col md="5">
                      <AvField
                        name="employee_askes_number"
                        placeholder="Askes / BPJS Kesehatan..."
                        type="text"
                        errorMessage="Masukkan Askes / BPJS Kesehatan"
                        className="form-control"
                        id="employee_askes_number"
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-3 col-form-label">Tapera</label>
                    <Col md="5">
                      <AvField
                        name="employee_tapera_number"
                        placeholder="Tapera..."
                        type="text"
                        errorMessage="Masukkan Tapera"
                        className="form-control"
                        id="employee_tapera_number"
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-3 col-form-label">Taspen</label>
                    <Col md="5">
                      <AvField
                        name="employee_taspen_number"
                        placeholder="Taspen..."
                        type="text"
                        errorMessage="Masukkan Taspen"
                        className="form-control"
                        id="employee_taspen_number"
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-3 col-form-label">NPWP</label>
                    <Col md="5">
                      <AvField
                        name="employee_npwp_number"
                        placeholder="NPWP..."
                        type="text"
                        errorMessage="Masukkan NPWP"
                        className="form-control"
                        id="employee_npwp_number"
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-3 col-form-label">
                      NIK
                      {/* <span className="text-danger">*</span> */}
                    </label>
                    <Col md="5">
                      <AvField
                        name="employee_identity_number"
                        placeholder="NIK..."
                        type="text"
                        errorMessage="Masukkan NIK"
                        className="form-control"
                        // validate={{ required: { value: true } }}
                        id="employee_identity_number"
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-3 col-form-label">
                      Nomor Dosir
                    </label>
                    <Col md="5">
                      <AvField
                        name="employee_dosir_number"
                        placeholder="Nomor Dosir..."
                        type="text"
                        errorMessage="Masukkan Nomor Dosir"
                        className="form-control"
                        id="employee_dosir_number"
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-3 col-form-label">
                      Telepon Rumah
                    </label>
                    <Col md="4">
                      <AvField
                        name="employee_phone_number"
                        placeholder="Telepon Rumah..."
                        type="text"
                        errorMessage="Masukkan Telepon Rumah"
                        className="form-control"
                        id="employee_phone_number"
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-3 col-form-label">Handphone</label>
                    <Col md="4">
                      <AvField
                        name="employee_mobile_phone_number"
                        placeholder="Handphone..."
                        type="number"
                        errorMessage="Masukkan Handphone"
                        className="form-control"
                        // validate={{ required: { value: true } }}
                        id="employee_mobile_phone_number"
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-3 col-form-label">
                      Email Internal <span className="text-danger">*</span>
                    </label>
                    <Col md="4">
                      <AvField
                        name="employee_email_internal"
                        placeholder="Email..."
                        type="email"
                        errorMessage="Masukkan Email"
                        className="form-control"
                        validate={{ required: { value: true } }}
                        id="employee_email_internal"
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-3 col-form-label">
                      Email Eksternal <span className="text-danger">*</span>
                    </label>
                    <Col md="4">
                      <AvField
                        name="employee_email_external"
                        placeholder="Email..."
                        type="email"
                        errorMessage="Masukkan Email"
                        className="form-control"
                        id="employee_email_external"
                        validate={{ required: { value: true } }}
                      />
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label className="col-md-3 col-form-label">
                      Enroll Number <span className="text-danger">*</span>
                    </label>
                    <Col md="4">
                      <AvField
                        name="enrol_number"
                        placeholder="Enroll Number..."
                        type="text"
                        errorMessage="Masukkan Enroll Number"
                        className="form-control"
                        id="enrol_number"
                        value={this.state.enrollnumber}
                        validate={{ required: { value: true } }}
                        onChange={(e) => this.handleInputChange(e.target.value)}
                      />
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Label className="col-md-3 col-form-label">
                      File Pendukung{" "}
                    </Label>
                    <Col md="6">
                      <FileInput name="file" col="6" />
                    </Col>
                  </Row>


                  <Row className="mb-3">
                    <label className="col-md-3 col-form-label">Nomor Kartu Keluarga <span className="text-danger">*</span></label>
                    <Col md="4">
                      <AvField
                        name="employee_family_card_number"
                        placeholder="Nomor Kartu Keluarga..."
                        type="number"
                        errorMessage="Masukkan Nomor Kartu Keluarga"
                        className="form-control"
                        validate={{ required: { value: true } }}
                        id="employee_family_card_number"
                      />
                    </Col>
                  </Row>


                  <Row className="mb-3">
                    <Label className="col-md-3 col-form-label">
                      File Kartu Keluarga{" "}  <span className="text-danger">*</span>
                    </Label>
                    <Col md="6">
                      <FileInput name="file_kk" col="6" required />
                    </Col>
                  </Row>




                  <hr />
                  <Row className="mb-3">
                    <Label className="col-md-3 col-form-label">
                      Maping Pola Kerja
                    </Label>
                  </Row>
                  <hr />
                  <Row className="mb-3">
                    <label
                      htmlFor="mapping_working_pattern_working_pattern_uuid"
                      className="col-md-3 col-form-label"
                    >
                      Pola Kerja <span className="text-danger">*</span>
                    </label>
                    <Col md="5">
                      <CustomSelect
                        name={`mapping_working_pattern_working_pattern_uuid`}
                        errorMessage="Pilih Pola Kerja"
                        options={this.state.polaKerjaOptions}
                        validate={{ required: { value: true } }}
                        placeholder="Pilih Pola Kerja"
                        isLoading={this.state.isLoadingOptPolaKerja}
                        onChange={(v) =>
                          this.setState({
                            selectedPolaKerja: v.model,
                          })
                        }
                      // defaultValue={data.type}
                      />
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label htmlFor="no_sk" className="col-md-3 col-form-label">
                      Pola Kerja Nama
                    </label>
                    <Col md="9">
                      <AvField
                        placeholder=""
                        name="mapping_working_pattern_working_pattern_name"
                        id="mapping_working_pattern_working_pattern_name"
                        readonly="readonly"
                        type="text"
                        className="form-control"
                        value={
                          this.state.selectedPolaKerja?.working_pattern_name
                        }
                      />
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Label className="col-md-3 col-form-label">
                      Tanggal Mulai <span className="text-danger">*</span>
                    </Label>
                    <Col md="3">
                      {/* <AvField
                                                name="mapping_working_pattern_start_date"
                                                placeholder="Tanggal Mulai"
                                                errorMessage="Masukkan Tanggal Mulai"
                                                type="date"
                                                className="form-control"
                                                onChange={e => { 
                                                    this.setState({ startDate: e.target.value });
                                                    // this.handleTanggalCuti(e.target.value)
                                                }}
                                                validate={{ required: { value: true } }}
                                            /> */}
                      <DatePicker
                        name="mapping_working_pattern_start_date"
                        placeholder="Tanggal Mulai"
                        errorMessage="Masukkan Tanggal Mulai"
                        isWeekday={false}
                        dateFormat="dd/MM/yyyy"
                        validate={{ required: { value: true } }}
                      // minDate={moment().add(5, 'days').format('YYYY-MM-DD')}
                      // minDate={this.state.minDate}
                      />
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Label className="col-md-3 col-form-label">
                      Tanggal Selesai <span className="text-danger">*</span>
                    </Label>
                    <Col md="3">
                      {/* <AvField
                                                name="mapping_working_pattern_end_date"
                                                placeholder="Tanggal Selesai"
                                                errorMessage="Masukkan Tanggal Selesai"
                                                type="date"
                                                className="form-control"
                                                onChange={e => { 
                                                    this.setState({ endDate: e.target.value })
                                                }}
                                                validate={{ required: { value: true } }}
                                                // min={this.state.minDateSelesai}
                                            /> */}
                      <DatePicker
                        name="mapping_working_pattern_end_date"
                        placeholder="Tanggal Selesai"
                        errorMessage="Masukkan Tanggal Selesai"
                        isWeekday={false}
                        dateFormat="dd/MM/yyyy"
                        validate={{ required: { value: true } }}
                      // minDate={moment().add(5, 'days').format('YYYY-MM-DD')}
                      // minDate={this.state.minDate}
                      />
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col md="3"></Col>
                    <Col md="9">
                      <Link to="/kepegawaian/home.html">
                        <Button color="danger">
                          <i className="uil-arrow-left"></i> Kembali
                        </Button>
                      </Link>{" "}
                      <Button color="success" type="submit">
                        <i className="uil-arrow-up-right"></i> Simpan Data
                      </Button>
                    </Col>
                  </Row>
                </AvForm>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin akan menyimpan data ini?"
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil disimpan"
          failedTitle="Gagal!"
          failedInfo={this.state.failedInfo}
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.redirect ? <Redirect to="/kepegawaian/home.html" /> : null}
      </Fragment>
    );
  }
}

export default ExternalInputComponent;
